import React from 'react';
import { Typography } from '@mui/material';
import PurchasesHome from '../pagesHome/PurchasesHome';

const BookkeepingDashboard = () => {

 return (
   <>
    <Typography variant="h5" align="right" sx={{ mb: 2, ml: 2 }}>
     רכישות הממתינות לאישור תשלום
    </Typography>
    <PurchasesHome filter={[{ field: 'purchaseStatus', value: 'פתוח' }]} />
   </>
 );
}

export default BookkeepingDashboard;
